/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestUserStatisticsGenerationByUsernameModel } from '../model/models';
import { ApiRequestUserStatisticsGenerationModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface UserStatisticsGenerationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestUserStatisticsGenerationModel 
     */
    userStatisticsGenerationControllerGenerate0(apiRequestUserStatisticsGenerationModel: ApiRequestUserStatisticsGenerationModel, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestUserStatisticsGenerationModel 
     */
    userStatisticsGenerationControllerGenerate1(apiRequestUserStatisticsGenerationModel: ApiRequestUserStatisticsGenerationModel, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestUserStatisticsGenerationByUsernameModel 
     */
    userStatisticsGenerationControllerGenerateByUsername0(apiRequestUserStatisticsGenerationByUsernameModel: ApiRequestUserStatisticsGenerationByUsernameModel, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestUserStatisticsGenerationByUsernameModel 
     */
    userStatisticsGenerationControllerGenerateByUsername1(apiRequestUserStatisticsGenerationByUsernameModel: ApiRequestUserStatisticsGenerationByUsernameModel, extraHttpRequestParams?: any): Observable<{}>;

}
